// Mesquite Mafia: Cloudflare D1 Sync & Authoritative Server Execution
import { state, log, escapeHtml, updateCurrencies, updateHUDDirective, enterGame } from '../core/state.js';
import { playSFX } from '../core/audio.js';
import { playerProfile, updateProfileUI } from '../dossiers/characters.js';
import { updateCompoundUI } from '../engine/compound.js';
import { hydrateMissionsFromSaved, renderMissions } from '../engine/missions.js';

export let sessionToken = localStorage.getItem("mesquite_session_token") || null;

export function updateStartScreenState(isRegistered) {
      const handle = localStorage.getItem("mesquite_player_handle");
      const playBtn = document.getElementById('btn-start-play');
      const registerBtn = document.getElementById('btn-start-register');

      if (isRegistered && handle && handle !== "UNREGISTERED BOSS" && handle !== "[ ROOKIE BOSS ]") {
        if (playBtn) {
          playBtn.innerHTML = `<span>PLAY [${escapeHtml(handle.toUpperCase())}]</span><span class="btn-arrow-icon">▶</span>`;
        }
        if (registerBtn) {
          registerBtn.innerHTML = `<span class="btn-crosshair-icon">⌖</span><span>SWITCH BOSS</span>`;
        }
      } else {
        if (playBtn) {
          playBtn.innerHTML = `<span>PLAY</span><span class="btn-arrow-icon">▶</span>`;
        }
        if (registerBtn) {
          registerBtn.innerHTML = `<span class="btn-crosshair-icon">⌖</span><span>REGISTER</span>`;
        }
      }
    }

export async function promptBossLogin() {
      playSFX('click');
      const handle = prompt("Enter your registered Syndicate Boss Handle to reconnect your ledger:", "");
      if (!handle || !handle.trim()) return;
      try {
        const resp = await fetch("/api/auth", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: handle.trim() })
        });
        if (resp.ok) {
          const data = await resp.json();
          if (data.sessionToken) {
            sessionToken = data.sessionToken;
            localStorage.setItem("mesquite_session_token", sessionToken);
            localStorage.setItem("mesquite_player_handle", data.player.username);
            playerProfile.handle = data.player.username;
            if (data.player.archetype) playerProfile.archetype = data.player.archetype;
            if (data.player.compound_level) state.compoundLevel = data.player.compound_level;
            if (data.player.missions_state_json) {
              try {
                hydrateMissionsFromSaved(JSON.parse(data.player.missions_state_json));
              } catch(e) {}
            }
            if (data.currencies) {
              state.cash = data.currencies.dirty_cash;
              state.product = data.currencies.product_bags;
              state.scrap = data.currencies.scrap_hardware;
              state.cred = data.currencies.street_cred;
              updateCurrencies();
            }
            updateProfileUI();
            updateStartScreenState(true);
            updateHUDDirective();
            renderMissions();
            updateCompoundUI();
            enterGame();
          }
        } else {
          alert("Boss identity not found in D1 ledger. Please register a new identity.");
        }
      } catch(e) {
        alert("Network error connecting to D1 ledger.");
      }
    }

export async function initCloudflareDB() {
      try {
        let storedHandle = localStorage.getItem("mesquite_player_handle");
        if (!storedHandle || storedHandle === "UNREGISTERED BOSS" || storedHandle === "[ ROOKIE BOSS ]") {
          sessionToken = null;
          updateStartScreenState(false);
          const syncEl = document.getElementById('sync-status');
          if (syncEl) {
            syncEl.innerText = "● Guest Session";
            syncEl.style.color = "#fbbf24";
          }
          return;
        }

        const resp = await fetch("/api/auth", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: storedHandle })
        });
        if (resp.ok) {
          const data = await resp.json();
          if (data.sessionToken) {
            sessionToken = data.sessionToken;
            localStorage.setItem("mesquite_session_token", sessionToken);
            localStorage.setItem("mesquite_player_handle", data.player.username);
            document.getElementById('player-handle').innerText = data.player.username;
            document.getElementById('sync-status').innerText = "● D1 Cloud Synced";
            document.getElementById('sync-status').style.color = "#4ade80";

            if (data.player && data.player.archetype) {
              playerProfile.archetype = data.player.archetype;
              const archTag = document.getElementById('player-archetype-tag');
              if (archTag) archTag.innerText = data.player.archetype.toUpperCase();
            }

            if (data.player && data.player.compound_level) {
              state.compoundLevel = data.player.compound_level;
            }

            if (data.player && data.player.missions_state_json) {
              try {
                hydrateMissionsFromSaved(JSON.parse(data.player.missions_state_json));
              } catch(e) {}
            }

            if (data.currencies) {
              state.cash = data.currencies.dirty_cash;
              state.product = data.currencies.product_bags;
              state.scrap = data.currencies.scrap_hardware;
              state.cred = data.currencies.street_cred;
              updateCurrencies();
            }
            updateStartScreenState(true);
            updateHUDDirective();
            renderMissions();
            updateCompoundUI();
            log("[DATABASE]: Connected to Cloudflare D1 edge database.");
          }
        } else {
          fallbackOffline();
        }
      } catch (err) {
        fallbackOffline();
      }
    }

export function fallbackOffline() {
      const handle = localStorage.getItem("mesquite_player_handle");
      if (handle && handle !== "UNREGISTERED BOSS" && handle !== "[ ROOKIE BOSS ]") {
        document.getElementById('player-handle').innerText = handle;
        document.getElementById('sync-status').innerText = "● Guest Session";
        document.getElementById('sync-status').style.color = "#fbbf24";
        updateStartScreenState(true);
        log("[DATABASE]: Guest session active. State preserved locally in browser.");
      } else {
        updateStartScreenState(false);
      }
    }

export async function syncStateToD1() {
      if (!sessionToken) return;
      try {
        await fetch("/api/player", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionToken
          },
          body: JSON.stringify({
            dirty_cash: state.cash,
            product_bags: state.product,
            scrap_hardware: state.scrap,
            street_cred: state.cred,
            compound_level: state.compoundLevel,
            missions_state_json: JSON.stringify(state.missions)
          })
        });
      } catch (e) {}
    }

export function openPlayerSignupModal() {
      const m = document.getElementById('modal-player-signup');
      if (!m) return;
      playSFX('click');

      const errEl = document.getElementById('signup-modal-error');
      if (errEl) errEl.style.display = 'none';

      const inputHandle = document.getElementById('input-player-handle');
      if (inputHandle) {
        inputHandle.value = (playerProfile.handle && playerProfile.handle !== "[ ROOKIE BOSS ]" && playerProfile.handle !== "UNREGISTERED BOSS") ? playerProfile.handle : "";
      }
      const inputMotto = document.getElementById('input-player-motto');
      if (inputMotto) inputMotto.value = playerProfile.motto || "From Mesquite Trenches to Riches";

      document.querySelectorAll('.avatar-choice-card').forEach(card => {
        card.classList.toggle('active', card.getAttribute('data-avatar') === playerProfile.avatar);
      });

      document.querySelectorAll('.archetype-card').forEach(card => {
        card.classList.toggle('active', card.getAttribute('data-archetype') === playerProfile.archetype);
      });

      m.style.display = 'flex';
    }

export function closePlayerSignupModal() {
      const m = document.getElementById('modal-player-signup');
      if (m) {
        m.style.display = 'none';
        playSFX('click');
      }
    }


// Server-Authoritative Execution Client Bridge
export async function callServerAction(action, payload = {}) {
  const token = localStorage.getItem("mesquite_session_token");
  if (!token) {
    return { status: "guest_allowed", action };
  }

  try {
    const res = await fetch("/api/action", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token
      },
      body: JSON.stringify({ action, payload })
    });

    const data = await res.json();
    if (!res.ok) {
      log(`[SERVER REJECTED]: ${data.error || "Action unauthorized."}`);
      return null;
    }

    if (data.currencies) {
      if (data.currencies.dirty_cash !== undefined) state.cash = data.currencies.dirty_cash;
      if (data.currencies.clean_capital !== undefined) state.cleanCapital = data.currencies.clean_capital;
      if (data.currencies.product_bags !== undefined) state.product = data.currencies.product_bags;
      if (data.currencies.scrap_hardware !== undefined) state.scrap = data.currencies.scrap_hardware;
      if (data.currencies.street_cred !== undefined) state.cred = data.currencies.street_cred;
      updateCurrencies();
    }

    if (data.compoundLevel !== undefined) {
      state.compoundLevel = data.compoundLevel;
      if (window.updateCompoundUI) window.updateCompoundUI();
    }

    if (data.message) {
      log(`[SECURE ACTION]: ${data.message}`);
    }

    return data;
  } catch (err) {
    console.warn('[SERVER ACTION]: Network offline fallback:', err);
    return { status: "offline_fallback" };
  }
}
